/**
 *
 * HomeFilter
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import withResize from 'components/ResizeContainer';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import _findIndex from 'lodash/findIndex';
import Hidden from '@material-ui/core/Hidden';
import { makeSelectFilterTopics } from 'containers/Topics/selectors';
import { getSources } from 'containers/Sources/actions';
import { getProgramsByTopic } from 'containers/Main/actions';
import ctf from 'utils/contentfulService';
import {
  makeSelectHomeHero,
  makeSelectProgramsByTopic,
} from 'containers/Main/selectors';
import {
  makeSelectFaq,
  makeSelectProcessing,
} from 'containers/Sources/selectors';
import { getTopics } from 'containers/Topics/actions';
import { withRouter } from 'react-router';
import MixPanel from 'utils/mixpanelService';
import withSizes from 'react-sizes';
import qs from 'qs';
import { styles } from './styles';
import { MEDIA_TYPES } from './constants';
import MobileScroll from './MobileScroll';
import DesktopScroll from './DesktopScroll';

/* eslint-disable */
// TODO: refactor this using new method calling algolia instead
class HomeFilter extends React.PureComponent {
  constructor(props) {
    super(props);

    const finalTopics = this.getFinalTopics();
    const firstTopicSlug = _get(finalTopics, '0.slug');
    this.state = {
      selectedTopic: firstTopicSlug || '',
      selectedRelatedTopic: 'ALL',
      selectedMediaType: 'ALL',
      mediaTypes: MEDIA_TYPES,
    };
  }

  componentDidMount() {
    const { filterTopics } = this.getTopicsFromData(this.props.data);
    if (_isEmpty(filterTopics)) {
      this.fetchTopics();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // set default selected topic to the most popular
    if (
      this.props.popularTopics !== nextProps.popularTopics &&
      !_isEmpty(nextProps.popularTopics)
    ) {
      const firstTopicSlug = nextProps.popularTopics[0].slug;
      this.setState(
        {
          selectedTopic: firstTopicSlug,
        },
        () => {
          this.getFaq(firstTopicSlug);
          this.getNews(firstTopicSlug);
          this.getProgramsByTopic(firstTopicSlug);
        },
      );
    }
    if (this.props.faq !== nextProps.faq) {
      if (!_isEmpty(_get(nextProps.faq, 'items'))) {
        if (_findIndex(this.state.mediaTypes, { value: 'FAQs' }) === -1) {
          const mediaTypesCopy = [...MEDIA_TYPES];
          mediaTypesCopy.splice(6, 0, {
            label: 'FAQs',
            value: 'FAQs',
          });
          this.setState({
            mediaTypes: mediaTypesCopy,
          });
        }
      } else {
        this.setState({ mediaTypes: MEDIA_TYPES });
      }
    }
    if (this.props.program !== nextProps.program) {
      const hasPrograms = !_isEmpty(_get(nextProps, 'program.items'));
      if (hasPrograms) {
        if (_findIndex(this.state.mediaTypes, { value: 'Online Programs' }) === -1) {
          const mediaTypesCopy = [...MEDIA_TYPES];
          mediaTypesCopy.push({
            label: 'Online Programs',
            value: 'Online Programs',
          });

          this.setState({
            mediaTypes: mediaTypesCopy,
          });
        }
      } else {
        this.setState({ mediaTypes: MEDIA_TYPES });
      }
    }

    if(this.props.defaultTopic !== nextProps.defaultTopic) {
      this.setState({
        selectedTopic: nextProps.defaultTopic
      })
    }

    if(this.props.data !== nextProps.data) {
      const { filterTopics, defaultTopic} = this.getTopicsFromData(nextProps.data);
      if(_isEmpty(filterTopics)) {
        if(_isEmpty(this.props.popularTopics)) {
          this.fetchTopics();
        } else {
          const firstTopicSlug = this.props.popularTopics[0].slug;
          this.setState(
            {
              selectedTopic: firstTopicSlug,
            },
            () => {
              this.getFaq(firstTopicSlug);
              this.getNews(firstTopicSlug);
              this.getProgramsByTopic(firstTopicSlug);
            },
          );
        }
      } else {
        this.setState({
          selectedTopic: defaultTopic
        })
      }
    }
  }

  fetchTopics = () => {
    const payload = {
      type: 'home-filter',
    };
    this.props.getTopics(payload);
  };

  changeFilter = ({ target: { value } }, type) => {
    if (type === 'selectedTopic') {
      this.getFaq(value);
      this.getNews(value);
      this.getProgramsByTopic(value);
    }
    this.setState({
      [type]: value,
    });
  };

  getFaq = selectedTopic => {
    const finalTopics = this.getFinalTopics();
    const selectedTopicObject = finalTopics.filter(item => item.slug === selectedTopic)[0];
    this.props.getSources({
      type: 'FAQ',
      limit: 1,
      topicId: _get(selectedTopicObject, 'sys.id'),
    });
  };

  getFinalTopics = () => {
    const { popularTopics, data } = this.props;
    const { filterTopics } = this.getTopicsFromData(data);
    const finalTopics = !_isEmpty(filterTopics) ? filterTopics : popularTopics;
    return finalTopics;
  };

  getTopicsFromData = (data) => {
    const finalData = data || this.props.data;
    const relatedTopics = _get(data, 'fields.topics') || [];
    const filterTopics = !_isEmpty(relatedTopics)
      ? relatedTopics.filter(el =>  !_isEmpty(_get(el, 'fields.reviewStatus')) &&
      el.fields.reviewStatus === 'Accepted').map(({ sys, fields: { title, slug } }) => ({
          sys,
          title,
          slug,
        }))
      : [];
    const defaultTopic = !_isEmpty(filterTopics) ? filterTopics[0].slug : '';
    return {
      filterTopics,
      defaultTopic
    };
  }

  getNews = async selectedTopic => {
    const finalTopics = this.getFinalTopics();
    const selectedTopicObject = finalTopics.filter(item => item.slug === selectedTopic)[0];
    const response = await ctf.getEntries({
      content_type: 'activity',
      'fields.reviewStatus': 'Accepted',
      'fields.type': 'News',
      limit: 1,
      'fields.topics.sys.id': _get(selectedTopicObject, 'sys.id'),
    });
    const hasNews = !_isEmpty(_get(response, 'items'));
    if (hasNews) {
      if (_findIndex(this.state.mediaTypes, { value: 'News' }) === -1) {
        const mediaTypesCopy = [...MEDIA_TYPES];
        mediaTypesCopy.push({
          label: 'News',
          value: 'News',
        });

        this.setState({
          mediaTypes: mediaTypesCopy,
        });
      }
    } else {
      this.setState({ mediaTypes: MEDIA_TYPES });
    }
  };

  getProgramsByTopic = selectedTopic => {
    const finalTopics = this.getFinalTopics();
    const selectedTopicObject = finalTopics.filter(item => item.slug === selectedTopic)[0];
    this.props.getProgramsByTopic({
      limit: 1,
      'fields.topics.sys.id': _get(selectedTopicObject, 'sys.id'),
    });
  };

  go = () => {
    const { selectedMediaType, selectedTopic, mediaTypes } = this.state;
    const finalTopics = this.getFinalTopics();
    const selectedTopicObject = finalTopics.filter(item => item.slug === selectedTopic)[0];

    const selectedTopicTitle = _get(selectedTopicObject, 'title');
    const selectedTopicSlug = _get(selectedTopicObject, 'slug');
    let typesFilter = `types=${selectedMediaType}`;
    if (selectedMediaType === 'ALL') {
      const types = mediaTypes
        .filter(type => !['ALL', 'People'].includes(type.value))
        .map(item => item.value);
      typesFilter = qs.stringify({ types });
    }

    MixPanel.track('Help Me With', {
      type: selectedMediaType,
      topic: selectedTopicTitle,
      path: window.location.pathname,
      name: selectedTopicTitle,
    });

    this.props.history.push(`/topics/${selectedTopicSlug}?${typesFilter}`);
  };

  isNotHomePage = () => {
    const { section } = this.props;
    return ['blog-page', 'person-page', 'resource-page'].includes(section);
  }
  render() {
    const {homeHero, clientData, forceMobile } = this.props;
    const hasHeroData = !_isEmpty(_get(homeHero, 'slug'));
    const { selectedTopic, selectedRelatedTopic, selectedMediaType, mediaTypes } = this.state;
    const finalTopics = this.getFinalTopics();
    if (_isEmpty(finalTopics)) return null;
    const topicsOption = finalTopics.map(({ title, slug }) => ({
      label: title,
      value: slug,
    }));
    const isNotHomePage = this.isNotHomePage();
    const variantOptions = {
      topicsOption,
      selectedTopic,
      changeFilter: this.changeFilter,
      mediaTypes,
      selectedMediaType,
      go: this.go,
      selectedRelatedTopic,
      isNotHomePage,
      hasHeroData,
      homeHero,
    };

    if (forceMobile) {
      return  <MobileScroll {...variantOptions} />;
    }
    return (
      <div>
        <Hidden xsDown>
          <DesktopScroll {...variantOptions}/>
        </Hidden>
        <Hidden smUp>
          <MobileScroll {...variantOptions} />
        </Hidden>
      </div>
    );
  }
}

HomeFilter.propTypes = {
  classes: PropTypes.object,
  popularTopics: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  location: PropTypes.object,
  getSources: PropTypes.func,
  faq: PropTypes.object,
  forceMobile: PropTypes.bool,
  processing: PropTypes.bool,
  section: PropTypes.string,
  defaultTopic: PropTypes.string,
  homeHero: PropTypes.object,
  isMobile: PropTypes.bool,
  data: PropTypes.object,
  getProgram: PropTypes.object,
  program: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  popularTopics: makeSelectFilterTopics(),
  faq: makeSelectFaq(),
  processing: makeSelectProcessing(),
  homeHero: makeSelectHomeHero(),
  program: makeSelectProgramsByTopic(),
});

function mapDispatchToProps(dispatch) {
  return {
    getTopics: payload => dispatch(getTopics(payload)),
    getSources: payload => dispatch(getSources(payload)),
    getProgramsByTopic: payload => dispatch(getProgramsByTopic(payload)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 600,
});

export default compose(
  withResize,
  withConnect,
  withStyles(styles),
  withRouter,
  withSizes(mapSizesToProps),
)(HomeFilter);
